import { api } from '@shared/config/axiosConfig';
import { mapPaginationResponse } from '@shared/utils/mapPaginationResponse';
import { buildEndpoint } from '@shared/utils/buildEndpoint';
import { clientFromDto, clientToDto } from '../mappers/clientsMapper';

const BASE_ENDPOINT = 'client';

const buildServiceEndpoint = ({ id, action } = {}) => {
  return buildEndpoint(BASE_ENDPOINT, { id, action });
}

export const getClients = async (data = {}) => {
  const params = {
    search_text: data.searchText,
    page: data.page,
    page_size: data.pageSize,
  };

  const endpoint = buildServiceEndpoint();
  const response = await api.get(endpoint, { params });
  return mapPaginationResponse(response, clientFromDto);
};

export const getClient = async (id) => {
  const endpoint = buildServiceEndpoint({ id });
  const response = await api.get(endpoint);
  return clientFromDto(response.data);
};

export const getClientsFromSoftseguros = async (data = {}) => {
  const params = {
    search_text: data.searchText,
  };

  const endpoint = buildServiceEndpoint({ action: 'from-softseguros' });
  const response = await api.get(endpoint, { params });
  return response.data.map(clientFromDto);
}

export const createClient = async (data) => {
  const payload = clientToDto(data);

  const endpoint = buildServiceEndpoint();
  const response = await api.post(endpoint, payload);
  return clientFromDto(response.data);
};

export const updateClient = async (id, data) => {
  const payload = clientToDto(data);

  const endpoint = buildServiceEndpoint({ id });
  const response = await api.put(endpoint, payload);
  return clientFromDto(response.data);
};

export const createOrUpdateClient = async (data) => {
  const payload = clientToDto(data);

  const endpoint = buildServiceEndpoint({ action: 'create-or-update' });
  const response = await api.post(endpoint, payload);
  return clientFromDto(response.data);
};